
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_36564_24557)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 3.5A1.5 1.5 0 0016.5 2h-9A1.5 1.5 0 006 3.5v9A1.5 1.5 0 007.5 14h9a1.5 1.5 0 001.5-1.5v-9zm-13 9C5 13.879 6.122 15 7.5 15H14v1.5a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 012 16.5v-9A1.5 1.5 0 013.5 6H5v6.5zm4-4.15v-.697a.5.5 0 01.5-.5h3.167V5.425c0-.379.45-.567.714-.3l2.49 2.558a.457.457 0 010 .636l-2.493 2.555a.417.417 0 01-.713-.3V8.85H9.5a.5.5 0 01-.5-.5z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_36564_24557"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 2)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    